<template>
  <div class="legacy-shell">
    <top-nav />
    <main id="scroll" class="legacy-content" @scroll="calcScroll"><slot name="content"></slot></main>
    <footer class="legacy-footer"><a href="/">Universtage</a><nav aria-label="Social links">
      <a href="https://twitter.com/universtage?lang=en" target="_blank" rel="noopener noreferrer">Twitter</a>
      <a href="https://t.me/UniverstageNews" target="_blank" rel="noopener noreferrer">Telegram</a>
      <a href="https://www.instagram.com/universtage" target="_blank" rel="noopener noreferrer">Instagram</a>
    </nav></footer>
    <button v-if="dataProps && dataProps.showUp && percentScroll > dataProps.percentShow" class="up-button" aria-label="Back to top" @click="scrollUp"><i class="fa fa-arrow-up" aria-hidden="true"></i></button>
  </div>
</template>
<script>
import TopNav from './TopNavBar';
export default {
  props: { dataProps: Object },
  components: { TopNav },
  data: () => ({ percentScroll: 0 }),
  methods: {
    scrollUp() { document.getElementById('scroll').scrollTo({top: 0, behavior: 'smooth'}); },
    calcScroll(event) { const el = event.target; this.percentScroll = 100 * el.scrollTop / Math.max(1, el.scrollHeight - el.clientHeight); }
  }
};
</script>
<style>
.legacy-shell { height: 100vh; height: 100dvh; display: flex; flex-direction: column; color: #242126; background: #f5f3f2; font-family: Arial, Helvetica, sans-serif; text-align: left; }
.legacy-content { flex: 1; min-height: 0; width: 100%; overflow-y: auto; overflow-x: clip; }
.legacy-shell .legacy-content .content { background: #f5f3f2 !important; }
.legacy-footer { display: flex; justify-content: space-between; gap: 16px; padding: 12px 4%; background: #101014; font-size: 12px; }
.legacy-footer a { color: #e6e0e1; }
.legacy-footer nav { display: flex; gap: 16px; flex-wrap: wrap; }
.legacy-shell .card { background: #fff; border: 1px solid #e3dedd; border-radius: 8px; box-shadow: none; }
.legacy-shell .form-control, .legacy-shell textarea { border: 1px solid #e3dedd; border-radius: 6px; color: #343038; max-width: 100%; }
.legacy-shell .form-control:focus, .legacy-shell textarea:focus { border-color: #a82d38 !important; box-shadow: 0 0 0 3px #a82d381a !important; }
.legacy-shell .btn { border-radius: 6px; text-transform: none; }
.legacy-shell .btn-primary, .legacy-shell .btn-danger, .legacy-shell .btn-filter-i, .legacy-shell .btn-filter-alt-i { background: #a82d38 !important; border-color: #a82d38 !important; color: #fff !important; }
.legacy-shell .btn-filter-alt, .legacy-shell .btn-outline-danger { border: 1px solid #c98990 !important; color: #a82d38 !important; background: white; }
.legacy-shell .btn-filter-alt:hover, .legacy-shell .btn-outline-danger:hover { background: #a82d38 !important; border-color: #a82d38 !important; color: white !important; }
.legacy-shell .btn-two.btn-primary:before, .legacy-shell .btn-two.btn-primary:after { background: #a82d38 !important; }
.legacy-shell .btn-filter-alt:focus, .legacy-shell .btn-filter-alt:active { border-color: #a82d38 !important; box-shadow: 0 0 0 3px #a82d381a !important; }
.legacy-shell .btn:hover { filter: brightness(.94); }
.legacy-shell .legacy-content a { color: #a82d38; }
.legacy-shell .legacy-content .nav-link { color: #6f656d !important; }
.legacy-shell .legacy-content .nav-link.active { color: #a82d38 !important; }
.legacy-shell .text-primary, .legacy-shell .btn-link, .legacy-shell .page-link { color: #a82d38 !important; }
.legacy-shell .page-item.active .page-link { background: #a82d38; border-color: #a82d38; color: white !important; }
.legacy-shell input:checked + label:before { color: #a82d38; }
.legacy-shell .nav-tabs .nav-link.active { color: #a82d38; border-bottom-color: #a82d38; }
.legacy-shell .cover-default { background: radial-gradient(ellipse at 65% 0%, #974450, #491b29 80%) !important; }
.legacy-shell .legacy-content .card-cover { height: 220px; }
.legacy-shell .legacy-content .cover-img { height: 130px; }
.legacy-shell .up-button { position: fixed; bottom: 54px; right: 16px; border: 0; border-radius: 50%; padding: 10px 14px; background: #a82d38; color: white; }
.legacy-shell :focus-visible { outline: 2px solid #a82d38; outline-offset: 3px; }
@media(max-width: 767px) { .legacy-footer { font-size: 11px; padding: 10px 16px; } .legacy-footer nav { gap: 10px; } .legacy-shell .media-body { min-width: 0; overflow-wrap: anywhere; } }
</style>
